import React, {useMemo} from 'react';
import {
  
  Table,
 
  TableContainer,
  
  useMediaQuery,
  useTheme,
 
} from '@mui/material';
import Sticky from 'react-stickynode';
import Link from 'next/link';

import {
  ResponsiveTable,
  StyledButtons,
  StyledChip,
  StyledDescriptionText,
  StyledPlanBox,
  StyledTableCell,
  StyledTableCellPlan,
  StyledTableCellPlanBox,
  StyledTableCellPlanPrice,
  StyledTableCellPlanText,
  StyledTableContainer,
  StyledTableHead,
  StyledTitle,
  TableRows,
} from './PricingFeature.style';
import { useTokensTable } from './usePricingFeature';
import { useTranslations } from 'hooks/useTranslations';
import PricingFeatureSolo from './PricingFeatursSolo';
import PricingFeatureTeam from './PricingFeatureTeam';

const BREAKPOINTS = {
  MOBILE: 'sm',
  TABLET: 'md',
};

const PricingFeatureDefault = ({ plans, categories, locale, detailUrl }) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down(BREAKPOINTS.MOBILE));
  const isTablet = useMediaQuery(
    theme.breakpoints.between(BREAKPOINTS.MOBILE, BREAKPOINTS.TABLET),
  );
  

  const { isBrowser, tableRef, stickyHeaderRef } = useTokensTable();
  const { t } = useTranslations();
  const PlanHeader = useMemo(
    () => (
      <StyledTableHead ref={stickyHeaderRef}>
        <TableRows>
          <StyledTableCell isMobile={isMobile} isTablet={isTablet}>
            {t('TokensTable.fonction')}
          </StyledTableCell>
          {plans.map((plan) => (
            <StyledTableCellPlan key={plan.id} isMobile={isMobile}>
              <StyledTableCellPlanBox isMobile={isMobile}>
                <StyledPlanBox>
                  <StyledTableCellPlanText
                    isMobile={isMobile}
                    isTablet={isTablet}
                  >
                    {locale === 'en-us' ? plan.name : plan.nameFR || plan.name}
                  </StyledTableCellPlanText>
                  {plan.badge && (
                    <StyledChip isMobile={isMobile}>
                      <Link href="https://www.dri.fr/">{plan.badge}</Link>
                    </StyledChip>
                  )}
                </StyledPlanBox>
                <StyledTableCellPlanPrice
                  isMobile={isMobile}
                  isTablet={isTablet}
                >
                  {plan.price.label ||
                    `${plan.price.amount ? plan.price.amount : '0'} ${plan.price.currency}/${t('month.month')}`}
                </StyledTableCellPlanPrice>
                <Link href={'https://www.app.swiftask.ai/'} style={{ textDecoration: 'none' }}>
                <StyledButtons>
                  {locale === 'en-us' ? plan.cta : plan.ctaFR || plan.cta}
                </StyledButtons>
                </Link>
              
              </StyledTableCellPlanBox>
            </StyledTableCellPlan>
          ))}
        </TableRows>
      </StyledTableHead>
    ),
    [plans, locale, isMobile, isTablet, t],
  );
  return (
    <StyledTableContainer
      isMobile={isMobile}
      isTablet={isTablet}
      ref={tableRef}
    >
      <StyledTitle isMobile={isMobile} isTablet={isTablet}>
        {t('TokensTable.Title')}
      </StyledTitle>

      <StyledDescriptionText isMobile={isMobile} isTablet={isTablet}>
        {t('TokensTable.Description')}
      </StyledDescriptionText>

      <ResponsiveTable>
        <TableContainer>
          {isBrowser && (
            <Sticky
              top={isMobile ? 80 : isTablet ? 100 : 140}
              bottomBoundary={tableRef.current}
              innerZ={999}
            >
              <Table>{PlanHeader}</Table>
            </Sticky>
          )}
          {detailUrl === 'TEAM' ? (
            <PricingFeatureTeam categories={categories} locale={locale} />
          ) : detailUrl === 'CREDIT' ? (
            <PricingFeatureTeam categories={categories} locale={locale} />
          ) : (
            <PricingFeatureSolo categories={categories} locale={locale} />
          )}
        </TableContainer>
      </ResponsiveTable>
    </StyledTableContainer>
  );
};

export default PricingFeatureDefault;
